<template>
  <div
    class="align-center background-color-white d-flex flex-column full-height justify-center pt-10 pb-6 text-center rounded-lg"
  >
    <StorefrontImage size="large" />
    <div class="font-size-lg font-weight-semibold">
      {{ wait(storeInfo, "name") }}
    </div>
    <div
      v-if="storeInfo"
      class="primary-color font-weight-semibold text-center"
    >
      {{ formattedAddress }}
      <br />
      {{ formattedPhone }}
    </div>
    <div class="font-italic font-weight-bold mt-2">
      {{ slogan }}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";
import { formatPhoneNumber, wait } from "@/util.js";

export default {
  name: "StoreTitle",
  components: { StorefrontImage },

  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
      slogan: (state) =>
        state.store.info.store_info.customization?.website.style.slogan,
    }),
    formattedAddress() {
      return this.storeInfo.singleline
        ? this.storeInfo.singleline.replace(", USA", "")
        : null;
    },
    formattedPhone() {
      return this.storeInfo.phone
        ? formatPhoneNumber(this.storeInfo.phone)
        : null;
    },
  },
  methods: {
    wait,
  },
};
</script>

<style></style>
